export class FundDataBasic {
  uid:number
  fund_id: number;
  fund_name?: string;
  fund_classification?: string;
  controlling_corporation?: string;
  managing_corporation?: string; 
  report_period?: string;
  inception_date?: string;
  target_population?: string; //TargetPopulation
  specialization?: string;
  sub_specialization?: string; // Normalized value (computed)
  original_sub_specialization?: string; // Original value from CSV
  deposits?: number;
  withdrawls?: number;
  internal_transfers?: number;
  net_monthly_deposits?: number;
  total_assets?: number;
  avg_annual_management_fee?: number;
  avg_deposit_fee?: number;
  monthly_yield?: number;
  year_to_date_yield?: number;
  yield_trailing_3_yrs?: number;
  yield_trailing_5_yrs?: number;
  avg_annual_yield_trailing_3yrs?: number;
  avg_annual_yield_trailing_5yrs?: number;
  standard_deviation?: number;
  alpha?: number;
  sharpe_ratio?: number;
  liquid_assets_percent?: number;
  stock_market_exposure?: number;
  stock_market_percent?: number; // אחוז חשיפה למניות
  foreign_exposure?: number;
  foreign_currency_exposure?: number;
  foreign_exposure_percent?: number;
  foreign_currency_exposure_percent?: number;
  managing_corporation_legal_id?: number;  //handler_code
  current_date?: string;
  id: number;  // מזהה ראשי
  file_type: FundFileType;  // טיפוס enum בצד שרת, כאן מייצגים כמחרוזת
  year?: number;
  actuarial_adjustment?: number;
  product_type?: number;
  rank_yield_trailing_3_yrs?: number;
  rank_yield_trailing_5_yrs?: number;
  rank_cumulative_12m_yield?: number;
  rank_sharpe_ratio?: number;
  rank_alpha?: number;
  rank_standard_deviation?: number;
  cumulative_12m_yield?: number;
  cumulative_6m_yield?: number;
  cumulative_24m_yield?: number;
  cumulative_yield_dynamic?: number;
  percentile_6m_yield?: number;
  percentile_12m_yield?: number;

  // Static keys for type-safe usage
  static fund_id: keyof FundDataBasic = "fund_id";
  static fund_name: keyof FundDataBasic = "fund_name";
  static fund_classification: keyof FundDataBasic = "fund_classification";
  static controlling_corporation: keyof FundDataBasic = "controlling_corporation";
  static managing_corporation: keyof FundDataBasic = "managing_corporation";
  static report_period: keyof FundDataBasic = "report_period";
  static inception_date: keyof FundDataBasic = "inception_date";
  static target_population: keyof FundDataBasic = "target_population";
  static specialization: keyof FundDataBasic = "specialization";
  static sub_specialization: keyof FundDataBasic = "sub_specialization";
  static original_sub_specialization: keyof FundDataBasic = "original_sub_specialization";
  static deposits: keyof FundDataBasic = "deposits";
  static withdrawls: keyof FundDataBasic = "withdrawls";
  static internal_transfers: keyof FundDataBasic = "internal_transfers";
  static net_monthly_deposits: keyof FundDataBasic = "net_monthly_deposits";
  static total_assets: keyof FundDataBasic = "total_assets";
  static avg_annual_management_fee: keyof FundDataBasic = "avg_annual_management_fee";
  static avg_deposit_fee: keyof FundDataBasic = "avg_deposit_fee";
  static monthly_yield: keyof FundDataBasic = "monthly_yield";
  static year_to_date_yield: keyof FundDataBasic = "year_to_date_yield";
  static yield_trailing_3_yrs: keyof FundDataBasic = "yield_trailing_3_yrs";
  static yield_trailing_5_yrs: keyof FundDataBasic = "yield_trailing_5_yrs";
  static avg_annual_yield_trailing_3yrs: keyof FundDataBasic = "avg_annual_yield_trailing_3yrs";
  static avg_annual_yield_trailing_5yrs: keyof FundDataBasic = "avg_annual_yield_trailing_5yrs";
  static standard_deviation: keyof FundDataBasic = "standard_deviation";
  static alpha: keyof FundDataBasic = "alpha";
  static sharpe_ratio: keyof FundDataBasic = "sharpe_ratio";
  static liquid_assets_percent: keyof FundDataBasic = "liquid_assets_percent";
  static stock_market_exposure: keyof FundDataBasic = "stock_market_exposure";
  static foreign_exposure: keyof FundDataBasic = "foreign_exposure";
  static foreign_currency_exposure: keyof FundDataBasic = "foreign_currency_exposure";
  static managing_corporation_legal_id: keyof FundDataBasic = "managing_corporation_legal_id";
  static current_date: keyof FundDataBasic = "current_date";
 
  static file_type: keyof FundDataBasic = "file_type";
  static year: keyof FundDataBasic = "year";
  static actuarial_adjustment: keyof FundDataBasic = "actuarial_adjustment";
  static product_type: keyof FundDataBasic = "product_type";
  static rank_yield_trailing_3_yrs: keyof FundDataBasic = "rank_yield_trailing_3_yrs";
  static rank_yield_trailing_5_yrs: keyof FundDataBasic = "rank_yield_trailing_5_yrs";
  static rank_cumulative_12m_yield: keyof FundDataBasic = "rank_cumulative_12m_yield";
  static rank_sharpe_ratio: keyof FundDataBasic = "rank_sharpe_ratio";
  static rank_alpha: keyof FundDataBasic = "rank_alpha";
  static rank_standard_deviation: keyof FundDataBasic = "rank_standard_deviation";
  static cumulative_12m_yield: keyof FundDataBasic = "cumulative_12m_yield";
  static cumulative_6m_yield: keyof FundDataBasic = "cumulative_6m_yield";
  static cumulative_24m_yield: keyof FundDataBasic = "cumulative_24m_yield";
  static cumulative_yield_dynamic: keyof FundDataBasic = "cumulative_yield_dynamic";
  static percentile_6m_yield: keyof FundDataBasic = "percentile_6m_yield";
  static percentile_12m_yield: keyof FundDataBasic = "percentile_12m_yield";
}

export enum FundFileType {
  GEMELNET = "GemelNet",
  PENSIANET = "PensiaNet",
  INSURANCENET = "InsuranceNet"
}
export enum TargetPopulation {
  SPECIFIC_FACTORY = "1",
  SPECIFIC_SECTOR = "2"
}


export interface FundDataYields {
  fund_id?: number | null;
  report_period?: string | null;
  monthly_yield?: number;
  year_to_date_yield?: number;
  yield_trailing_3_yrs?: number;
  yield_trailing_5_yrs?: number;
  cumulative_12m_yield?: number;
  cumulative_6m_yield?: number;
  cumulative_24m_yield?: number;
}

export interface FundFacet {
  distinct_field_name: string;
  distinct_field_values: any[];
}


